import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取优惠券购买记录列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回优惠券购买记录列表
 */
export function listCouponDetail(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/couponDetail.listCouponDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}